/* L'Atelier de la Poêle — scripts de page (V7.6, 14/10/2026).
   Autrefois écrits dans layout/theme.liquid ; regroupés ici pour alléger le HTML. Sur l'accueil et les articles, ce
   fichier est chargé après l'affichage de la grande image (apApresAffichage) ; ailleurs, en « defer ».
   1. Transition fondue vers la page diagnostic. 2. Noms personnalisés dans le panier (MoonBundle). 3. Sous-total. */

/* 1. Transition fondue */
(function(){
'use strict';

var overlay=document.getElementById('transition-overlay');
if(!overlay)return;
var transitioning=false;

// V7.6 : la page est un article quand <html> porte data-ap-funnel (ancienne condition Liquid ap_funnel_edge).
if(!document.documentElement.hasAttribute('data-ap-funnel')){// Prefetch diagnostic page, seulement quand un lien vers elle est survolé, touché ou atteint au
// clavier : avant le 13/10/2026, la page entière était téléchargée à chaque visite, pendant l'affichage.
if(location.pathname.indexOf('/pages/diagnostic')===-1){
  var diagPrefetched=false;
  var prefetchDiag=function(e){
    if(diagPrefetched||!e.target||!e.target.closest)return;
    var a=e.target.closest('a[href*="/pages/diagnostic"]');
    if(!a)return;
    diagPrefetched=true;
    var pf=document.createElement('link');
    pf.rel='prefetch';pf.href=a.href;pf.as='document';
    document.head.appendChild(pf);
  };
  ['pointerover','touchstart','focusin'].forEach(function(t){document.addEventListener(t,prefetchDiag,{passive:true,capture:true});});
}}

// On diagnostic page: hide overlay, no interception needed
if(location.pathname.indexOf('/pages/diagnostic')!==-1){
  overlay.style.display='none';
  return;
}

document.addEventListener('click',function(e){
  var el=e.target,link=null;
  while(el&&el!==document){
    if(el.tagName==='A'&&el.href){link=el;break}
    el=el.parentElement;
  }
  if(!link)return;
  if(link.href.indexOf('/pages/diagnostic')===-1)return;
  if(transitioning)return;
  e.preventDefault();
  transitioning=true;
  var href=link.href;

  // Phase 1: fade to opaque brown
  overlay.style.pointerEvents='all';
  overlay.style.opacity='1';

  // Phase 2: fetch diagnostic page in parallel
  var fetched=null;
  var fetchFailed=false;
  fetch(href,{credentials:'same-origin'}).then(function(r){
    if(!r.ok)throw new Error(r.status);
    return r.text();
  }).then(function(html){
    fetched=html;
  }).catch(function(){
    fetchFailed=true;
  });

  // Phase 3: once overlay is opaque, swap or fallback
  var swapped=false;
  function onOpaque(){
    if(swapped)return;
    swapped=true;

    if(fetchFailed){
      window.location.href=href;
      return;
    }
    if(!fetched){
      var iv=setInterval(function(){
        if(fetched){clearInterval(iv);doSwap()}
        else if(fetchFailed){clearInterval(iv);window.location.href=href}
      },30);
      setTimeout(function(){clearInterval(iv);if(!fetched)window.location.href=href},5000);
      return;
    }
    doSwap();
  }

  function doSwap(){
    var doc=new DOMParser().parseFromString(fetched,'text/html');

    // ── Clean fetched DOM: remove THIS snippet's elements ──
    // The fetched page includes theme.liquid which contains this snippet.
    // We must remove our overlay div and script from the parsed doc
    // to avoid duplicates and re-execution.
    var snippetOvs=doc.querySelectorAll('#transition-overlay');
    for(var s=0;s < snippetOvs.length;s++)snippetOvs[s].parentNode.removeChild(snippetOvs[s]);
    var snippetScripts=doc.querySelectorAll('script[data-atel-snippet]');
    for(var s=0;s < snippetScripts.length;s++)snippetScripts[s].parentNode.removeChild(snippetScripts[s]);

    // Inject new page's head styles
    var newHeadEls=doc.querySelectorAll('head style, head link[rel="stylesheet"]');
    for(var i=0;i < newHeadEls.length;i++){
      document.head.appendChild(document.adoptNode(newHeadEls[i]));
    }

    // Update title
    if(doc.title)document.title=doc.title;

    // Detach our overlay, replace body, re-attach overlay
    overlay.parentNode.removeChild(overlay);
    document.body.innerHTML=doc.body.innerHTML;
    document.body.appendChild(overlay);

    // Update URL
    history.pushState(null,'',href);

    // Activate scripts (innerHTML doesn't execute them)
    var scripts=document.body.querySelectorAll('script');
    for(var j=0;j < scripts.length;j++){
      var old=scripts[j];
      var ns=document.createElement('script');
      if(old.src){ns.src=old.src}
      else{ns.textContent=old.textContent}
      for(var k=0;k < old.attributes.length;k++){
        var at=old.attributes[k];
        if(at.name!=='src')ns.setAttribute(at.name,at.value);
      }
      old.parentNode.replaceChild(ns,old);
    }

    // Phase 4: reveal
    requestAnimationFrame(function(){requestAnimationFrame(function(){
      overlay.style.opacity='0';
      setTimeout(function(){
        overlay.style.pointerEvents='none';
        transitioning=false;
      },560);
    })});
  }

  // Trigger swap when overlay is fully opaque
  var triggered=false;
  overlay.addEventListener('transitionend',function onEnd(ev){
    if(ev.propertyName==='opacity'&&!triggered){
      triggered=true;
      overlay.removeEventListener('transitionend',onEnd);
      onOpaque();
    }
  });
  setTimeout(function(){if(!triggered){triggered=true;onOpaque()}},600);

},true);

})();

/* 2. Noms personnalisés dans le panier */
/* ===== L'Atelier de la Poêle - Noms personnalisés dans le panier (MoonBundle) =====
   Lit le métachamp custom.nom_produit_panier via l'API Storefront et remplace le titre.
   Réapplication SYNCHRONE à chaque redessin MoonBundle pour supprimer le clignotement
   du nom complet lors d'une suppression de variante. */
(function () {
  'use strict';

  /* --- Réglages --- */
  var STOREFRONT_TOKEN = '432749efbaec780cdb5ea2680b92b3d4'; // jeton PUBLIC Storefront
  var API_VERSION      = '2026-01';
  var NAMESPACE        = 'custom';
  var KEY              = 'nom_produit_panier';
  var DEBUG            = false;

  /* --- Sélecteurs MoonBundle --- */
  var ITEM_SELECTOR  = '.moonbundle-cart-item-container';
  var TITLE_LINK_SEL = '.moonbundle-cart-item-title-link';
  var TITLE_SEL      = '.moonbundle-cart-item-title';

  var nameCache = {}; // handle -> string | null
  var inFlight  = {}; // handle -> true pendant la requête réseau

  function log() { if (DEBUG && window.console) console.log.apply(console, ['[ADLP panier]'].concat([].slice.call(arguments))); }

  function handleFromItem(item) {
    var link = item.querySelector(TITLE_LINK_SEL) || item.querySelector('a[href*="/products/"]');
    if (!link) return null;
    var href = link.getAttribute('href') || '';
    var m = href.match(/\/products\/([^\/?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }

  function titleTarget(item) {
    return item.querySelector(TITLE_LINK_SEL) || item.querySelector(TITLE_SEL);
  }

  /* Passe SYNCHRONE: applique tout de suite les noms déjà connus, avant le repaint.
     C'est ce qui supprime le clignotement. Idempotent: ne touche au texte que s'il diffère. */
  function applyCachedSync() {
    var items = document.querySelectorAll(ITEM_SELECTOR);
    for (var i = 0; i < items.length; i++) {
      var handle = handleFromItem(items[i]);
      if (!handle || !(handle in nameCache)) continue;
      var name = nameCache[handle];
      if (!name) continue; // pas de nom perso -> on laisse le titre par défaut
      var target = titleTarget(items[i]);
      if (target && target.textContent !== name) target.textContent = name;
    }
  }

  function buildQuery(handles) {
    var parts = handles.map(function (h, i) {
      return 'p' + i + ': product(handle: ' + JSON.stringify(h) + ') { metafield(namespace: ' + JSON.stringify(NAMESPACE) + ', key: ' + JSON.stringify(KEY) + ') { value } }';
    });
    return '{ ' + parts.join(' ') + ' }';
  }

  function fetchNames(handles, done) {
    handles = handles.filter(function (h) { return !(h in nameCache) && !inFlight[h]; });
    if (!handles.length) { if (done) done(); return; }
    handles.forEach(function (h) { inFlight[h] = true; });
    fetch(window.location.origin + '/api/' + API_VERSION + '/graphql.json', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': STOREFRONT_TOKEN },
      body: JSON.stringify({ query: buildQuery(handles) })
    })
      .then(function (r) { return r.json(); })
      .then(function (json) {
        var data = (json && json.data) || {};
        handles.forEach(function (h, i) {
          var node = data['p' + i];
          var val = (node && node.metafield && node.metafield.value) ? String(node.metafield.value).trim() : null;
          nameCache[h] = val || null;
          delete inFlight[h];
          log('nom', h, '->', nameCache[h]);
        });
        if (done) done();
      })
      .catch(function (e) {
        handles.forEach(function (h) { delete inFlight[h]; });
        log('erreur API', e);
        if (done) done();
      });
  }

  function collectMissing() {
    var hs = [];
    var items = document.querySelectorAll(ITEM_SELECTOR);
    for (var i = 0; i < items.length; i++) {
      var h = handleFromItem(items[i]);
      if (h && !(h in nameCache) && !inFlight[h] && hs.indexOf(h) === -1) hs.push(h);
    }
    return hs;
  }

  var t = null;
  function scheduleFetch() {
    clearTimeout(t);
    t = setTimeout(function () {
      var hs = collectMissing();
      if (hs.length) fetchNames(hs, applyCachedSync);
    }, 60);
  }

  function onMutation() {
    applyCachedSync(); // immédiat: corrige le clignotement
    scheduleFetch();   // différé: va chercher les noms manquants
  }

  function prefetchFromCart() {
    fetch(window.location.origin + '/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var hs = (cart.items || []).map(function (it) { return it.handle; }).filter(Boolean);
        fetchNames(hs, applyCachedSync);
      })
      .catch(function () {});
  }

  function init() {
    // Panier vide au chargement : rien à prérenseigner, donc pas d'appel /cart.js (13/10/2026).
    // Les noms des articles ajoutés ensuite sont cherchés par l'observateur, comme avant.
    // V7.6 : nombre d'articles lu dans le JSON #atelier-cart-data (même valeur que cart.item_count côté Liquid).
    var nbArticles = 0;
    try { nbArticles = (JSON.parse(document.getElementById('atelier-cart-data').textContent).items || []).length; } catch (e) {}
    if (nbArticles > 0) prefetchFromCart();
    applyCachedSync();
    scheduleFetch();
    new MutationObserver(onMutation).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* 3. Sous-total */
/* ===== L'Atelier de la Poêle - sous-total : prix à gauche, prix barré à droite ===== */
(function () {
  'use strict';
  function leafSubtotal() {
    var all = document.querySelectorAll('div,span,p,strong,h2,h3,h4');
    for (var i = 0; i < all.length; i++) {
      var e = all[i];
      if (!e.children.length && /sous[-\s]?total/i.test(e.textContent || '')) return e;
    }
    return null;
  }
  function isStruck(el) {
    var d = '';
    try { d = getComputedStyle(el).textDecorationLine || ''; } catch (e) {}
    return d.indexOf('line-through') !== -1;
  }
  function fix() {
    var leaf = leafSubtotal();
    if (!leaf) return;
    var node = leaf.parentElement, hops = 0, struck = null;
    while (node && hops < 4 && !struck) {
      var cands = node.querySelectorAll('span,s,del,p,div');
      for (var j = 0; j < cands.length; j++) {
        var c = cands[j];
        if (c === leaf || c.contains(leaf)) continue;
        if (isStruck(c) && /\d/.test(c.textContent || '')) { struck = c; break; }
      }
      node = node.parentElement; hops++;
    }
    if (!struck) return;
    var box = struck.parentElement;
    if (!box || box.contains(leaf)) return;              // ne jamais déplacer le libellé
    if (box.getAttribute('data-adlp-sub') === '1') return;
    var current = null, kids = box.children;
    for (var k = 0; k < kids.length; k++) {
      if (kids[k] === struck) continue;
      if (/\d/.test(kids[k].textContent || '')) { current = kids[k]; break; }
    }
    if (current && current !== box.firstElementChild) box.insertBefore(current, box.firstElementChild);
    box.setAttribute('data-adlp-sub', '1');
  }
  var t = null;
  function sched() { clearTimeout(t); t = setTimeout(fix, 120); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sched);
  else sched();
  new MutationObserver(sched).observe(document.body, { childList: true, subtree: true });
})();
